import { Box, ToggleButton } from '@mui/material';
import useLocalization from '../../hooks/useLocalization';
import usePaymentProviders from '../../hooks/payment/usePaymentProviders';
import { PaymentTransactionType, PAYMENT_TRANSACTION_TYPE } from '../../types/enums';
import { PaymentProvider } from '../../types/payment';

const styles = {
  providerButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'neutral.600',
    color: 'neutral.200',
    borderRadius: 2,
    p: 2,
    flex: 1,
    '&.Mui-selected': {
      borderColor: 'primary.main',
      '&:hover': {
        borderColor: 'primary.main',
      },
    },
    '&:hover': {
      borderColor: 'primary.main',
      '& .MuiTypography-root': {
        color: 'neutral.25',
      },
    },
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mb: 1,
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 2,
  },
  providerIcon: {
    fontSize: '2.5rem',
  },
};

const PaymentProviders = ({
  transactionType,
  selectedProvider,
  onProviderChange,
  paymentProviders,
  paymentGateway,
}: {
  transactionType: PaymentTransactionType;
  selectedProvider: string | null;
  onProviderChange: (provider: string) => void;
  paymentProviders: PaymentProvider[];
  paymentGateway: string;
}) => {
  const { t } = useLocalization();
  const instructionMessage =
    transactionType === PAYMENT_TRANSACTION_TYPE.DEPOSIT ? t('chooseAPaymentMethod') : t('selectAWithdrawalMethod');

  const providersByTransactionType = usePaymentProviders(paymentProviders, transactionType, paymentGateway);

  return (
    <Box role='group' aria-label={instructionMessage} sx={styles.gridContainer}>
      {providersByTransactionType.map((provider) => {
        const IconComponent = provider.icon;

        return (
          <ToggleButton
            key={provider.value}
            value={provider.value}
            sx={styles.providerButton}
            onClick={() => onProviderChange(provider.value)}
            selected={selectedProvider === provider.value}
          >
            <Box sx={styles.iconBox}>
              <IconComponent sx={styles.providerIcon} />
            </Box>
            <Box component='span'>{provider.label}</Box>
          </ToggleButton>
        );
      })}
    </Box>
  );
};

export default PaymentProviders;
